import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./pages/App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import { store } from "./store/store";
import { BrowserRouter } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

const container = document.getElementById("root")!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <ScrollToTop>
            <App />
          </ScrollToTop>
        </I18nextProvider>
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
